var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1825 2.70501C13.4169 1.94838 12.3839 1.52405 11.3075 1.52405C10.2311 1.52405 9.19809 1.94838 8.4325 2.70501L8 3.12751L7.575 2.70501C6.80154 1.99834 5.78537 1.61714 4.73797 1.64076C3.69056 1.66438 2.6926 2.09098 1.95178 2.8318C1.21097 3.57262 0.78436 4.57058 0.760744 5.61798C0.737128 6.66539 1.11832 7.68156 1.825 8.45501L7.735 14.38C7.80563 14.4496 7.90082 14.4887 8 14.4887C8.09917 14.4887 8.19437 14.4496 8.265 14.38L14.1825 8.46251C14.9414 7.6966 15.3672 6.66199 15.3672 5.58376C15.3672 4.50554 14.9414 3.47093 14.1825 2.70501Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.adc64e4f18389dadb4626248b084df7f.svg";
export { ForwardRef as ReactComponent };